export function Credentials() {
  const items = [
    {
      tag: "Award · 2024",
      title: "Best Design Academy in Armenia",
      org: "Pixel Academy",
      body: "20+ cohorts, 60%+ graduates placed into product roles.",
      badge: (
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7" />
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
        </svg>
      ),
      featured: true,
    },
    {
      tag: "Certificate · 2023",
      title: "Google UX Design Professional",
      org: "Google · Coursera",
      body: "End-to-end UX certificate. Empathy, wireframes, prototypes, accessibility.",
      badge: (
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
    },
    {
      tag: "Reach · since 2014",
      title: "59,715+ Behance views",
      org: "Behance · global",
      body: "3,400+ appreciations across AI, fintech and Web3 projects.",
      badge: (
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ),
      stat: "59,715",
      statLabel: "Views",
    },
    {
      tag: "Education · 2018",
      title: "Master's in Design",
      org: "NUACA · Yerevan",
      body: "Design fundamentals, composition, and systems thinking.",
      badge: (
        <svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="creds dark" id="credentials">
      <div className="container">
        <div className="creds-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>Best in Armenia · 2024</span>
          <h2 className="display creds-title" data-reveal style={{ "--reveal-delay": "80ms" }}>
            Certified,<br />trusted &amp;<br /><em>on the record.</em>
          </h2>
        </div>

        <div className="creds-grid">
          {items.map((c, i) => (
            <article key={i} className={`cred ${c.featured ? "cred-featured" : ""}`} data-reveal style={{ "--reveal-delay": `${i * 70}ms` }}>
              <div className="cred-badge">{c.badge}</div>
              <div className="cred-meta">
                <span className="cred-tag">{c.tag}</span>
                <h3 className="display cred-title">{c.title}</h3>
                <span className="cred-org">{c.org}</span>
                <p className="cred-body">{c.body}</p>
              </div>
              {c.stat && (
                <div className="cred-stat">
                  <span className="display">{c.stat}</span>
                  <span>{c.statLabel}</span>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
